<template>
    <van-popup @click-overlay="closePopup" v-model:show="show" position="bottom" :style="{ height: '80%', zIndex:'10002' }"
        class="notice-popup">
        <img class="closeIcon" src="@/assets/common/cs_close.png" @click="closePopup()" />
        <p class="title-text">{{ $t('home.latestNews') }}</p>
        <div class="notice-content" v-html="$t('home.noticeContent')"></div>
        <div class="container">
            <div class="button-style" @click="closePopup()">{{ $t('home.IUnderstand') }}</div>
        </div>
    </van-popup>
</template>
<script lang="ts" setup>
import { ref, defineExpose } from 'vue';
const show = ref(false)
const openPopup = () => {
    show.value = true;
}

const closePopup = () => {
    show.value = false;
}

defineExpose({
    openPopup
})
</script>
<style scoped>
.closeIcon {
    right: 0%;
    position: absolute;
    width: 1.5rem;
    margin-top: 1rem;
    margin-right: 1rem;
}

.container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.button-style {
    padding: 1.0rem 2.0rem;
    border-radius: 8px;
    background-color: #3498db;
    color: #fff;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease;
    align-items: center;
    background-image: linear-gradient(270deg, rgb(225, 81, 164), rgb(230, 111, 200));
    border-radius:10px;
    font-size: 1.1rem;
}

.notice-popup {
    border-top-left-radius: 0.44rem !important;
    border-top-right-radius: 0.44rem !important;
    border: 0.5px solid rgba(255, 255, 255, 0.15) !important;
    background: #221b24 !important;
    opacity: 0.8 !important;
}

.notice-content {
    color: #86718c;
    text-align: center;
    padding: 1rem 3rem;
    line-height: 1.5rem;
    font-size: 16px;
    text-align: left;
}

.title-text {
    color: #ff69b4;
    text-align: center;
    padding: 0.5rem 4rem;
    font-size: 17px;
    font-weight: bold;
}

.van-overlay {
    backdrop-filter: blur(5px);
    z-index: 10001 !important;
}
</style>